module.exports = __webpack_public_path__ + "assets/static/svg/payment-sent.53d5b1c47bc166fe8a6595695a9da108.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/serviceReceipt/images/payment-sent.svg
 ** module id = 531
 ** module chunks = 1
 **/